<template>
<div class="commissionsDialog">
    <el-dialog @close='cancel' :title="'统一设置推荐佣金'" :visible.sync="dialogVisible" width="600px">
        <el-form :model="item" :rules="rules" ref="ruleForm" label-width="200px" class="demo-ruleForm form">
            <el-form-item label="设置推荐团长佣金（%）" prop="recommendrate" class="content">
                <el-input v-model.trim="item.recommendrate" placeholder="请输入推荐团长佣金" clearable></el-input>
            </el-form-item>
            <el-form-item class="form-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="submit">确 定</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</div>
</template>

<script>
import {uploadHostHeaderDefaultRecommendBrokerage}  from 'api/brandBusiness'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'commissionsDialog',
    data() {
        let validateHeaderrate = (rule, value, callback) => {
            if (parseFloat(value) > 100) {
                callback(new Error('团长佣金比例不能超过100%'))
            } else {
                callback()
            }
        }
        let validateRecommendrate = (rule, value, callback) => {
            if (parseFloat(value) > 100) {
                callback(new Error('推荐团长佣金团长佣金比例不能超过100%'))
            } else {
                callback()
            }
        }
        return {
            dialogVisible: false,
            item: {
                rolehostinnerid: '',
                hostroletype: 3,
                recommendrate: ''
            },
            rules: {
                recommendrate: [
                    {required: true, message: '请输入推荐团长佣金', trigger: 'blur'},
                    {pattern: /^(0|[1-9][0-9]*)+(\.[0-9]{1,2})?$/, message: '请输入正确的推荐团长佣金(2位小数)', trigger: 'blur'},
                    {validator: validateRecommendrate, trigger: 'blur'},
                ]
            }
        }
    },
    mounted() {
    },
    methods: {
        openDialog() {
            this.item.rolehostinnerid = this.brandBusiness.hostid
            this.item.recommendrate = ''
            this.dialogVisible = true
        },
        cancel() {
            this.dialogVisible = false
        },
        submit() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.$confirm('确认统一设置推荐佣金', '提示', {
                        confirmButtonText: '确认',
                        cancelButtonText: '取消'
                    }).then(() => {
                        this._save()
                    })
                }
            })
        },
        _save() {
            this.setLoading(true)
            uploadHostHeaderDefaultRecommendBrokerage({
                data: Object.assign({}, this.item),
                success: data => {
                    this.setLoading(false)
                    this.$message.success('统一设置推荐佣金成功')
                    this.$emit('getList')
                    this.cancel()
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([ 'user', 'params', 'brandBusiness'])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.commissionsDialog {
}
</style>
